<div class="invite-to-apply-modal vertical-center">
  <div class="title">Invite {{data.candidateName}} to apply</div>
  <div class="job-link">
    <span>Job link:&nbsp;</span>
    <a
      href="{{data.url}}"
      target="_blank"
    >{{data.url}}</a>
  </div>
  <div class="invite-to-apply-modal-buttons">
    <button
      color="accent"
      class="mr-2"
      mat-button
      type="button"
      (click)="closeDialog()"
    >Cancel
    </button>
    <button
      color="primary"
      class="md"
      mat-flat-button
      type="button"
      (click)="sendInviteToApply()"
    >INVITE
    </button>
  </div>

</div>
